import React from 'react';
import { RadioOption, RadioProps } from '..';
import { useCustomComponent } from '@/hooks';

export interface RadioItemProps extends RadioProps {
  option: RadioOption;
  isSelected: boolean;
  children: React.ReactNode;
}

export const ItemComponent: React.FC<RadioItemProps> = ({ children }) => {
  return <label className="peptalk-radio-label">{children}</label>;
};

export const Item: React.FC<RadioItemProps> = (props: RadioItemProps) => {
  const Component = useCustomComponent({
    componentName: 'RadioItem',
    Component: ItemComponent,
  });

  return <Component {...props} />;
};
